var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepublicOfMacedonia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FFDA44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4333 31.8161C21.0355 31.4191 23.4309 30.3943 25.4618 28.9024L16 16L18.4333 31.8161Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5664 0.184052C10.9642 0.581052 8.56884 1.6058 6.53784 3.09761L15.9997 16.0001L13.5664 0.184052Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53784 28.9024C8.56871 30.3942 10.9641 31.419 13.5663 31.8161L15.9997 16L6.53784 28.9024Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09716 6.53824C1.60528 8.56924 0.580656 10.9646 0.183594 13.5668L15.9997 16.0001L3.09716 6.53824Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.183594 18.4333C0.580594 21.0355 1.60534 23.4309 3.09722 25.4618L15.9997 16L0.183594 18.4333Z",
    fill: "#D80027"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8161 13.5668C31.419 10.9646 30.3943 8.56927 28.9024 6.53833L16 16.0001L31.8161 13.5668Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4618 3.09755C23.4308 1.60574 21.0355 0.581052 18.4333 0.184052L16 16.0001L25.4618 3.09755Z",
    fill: "#D80027"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9026 25.4618C30.3944 23.4309 31.4191 21.0354 31.8162 18.4333L16 16L28.9026 25.4618Z",
    fill: "#D80027"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5652C19.0736 21.5652 21.5652 19.0735 21.5652 16C21.5652 12.9264 19.0736 10.4348 16 10.4348C12.9264 10.4348 10.4348 12.9264 10.4348 16C10.4348 19.0735 12.9264 21.5652 16 21.5652Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 20.1741C18.3053 20.1741 20.1741 18.3054 20.1741 16.0002C20.1741 13.695 18.3053 11.8262 16.0001 11.8262C13.6949 11.8262 11.8262 13.695 11.8262 16.0002C11.8262 18.3054 13.6949 20.1741 16.0001 20.1741Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepublicOfMacedonia);
export default __webpack_public_path__ + "static/media/republic-of-macedonia.bf98235e.svg";
export { ForwardRef as ReactComponent };